import React from "react";

const TermsAndConditionsScreen = () => {
  return <></>;
};

export default TermsAndConditionsScreen;
